module.exports = __webpack_public_path__ + "img/dark_brown.8d397663.svg";